import { useState, useRef, Fragment } from "react";
import Config from "../../Config";


import back from "../../back.png";
import Lesson from "./Lesson";
import DayPlan from "./DayPlan";
import WeekPlan from "./WeekPlan";
import Kids from "./Kids";
import Free from "./Free";
import Trips from "./Trips";
import Mets from "./Mets";
import Dots from "./Dots";
import Settings from "./Settings";
import Psychologist from "./Psychologist";
import Controls from "./Controls";
import Hours from "./Hours";


function BooksEdit(props)
{

    const [row, setRowX] = useState(null);

    const [selectedTab, setSelectedTab] = useState("tematy");
    const [selectedTitle, setSelectedTitle] = useState(" / Dziennik zajęć");



        const valChecker = (fields) => {

            var allValid = true;
    
                  
            console.log(JSON.stringify(fields) );

            Object.entries(fields).forEach(function(entry) {
    
                var xKey    = entry[0];
                var xValue  = entry[1];                    

                var xValidName = xKey + "_valid";
    
                if(fields[xValidName] == false)
                {
                    allValid = false;
                    console.log("Error field: " + xKey);
                }
                
              });
            
              return allValid;
    
        }
    

        const valChangeListener = (filedName, val, correct, msg) => {         
         
          
            var tmpRow = row;
            tmpRow[filedName] = val;
            tmpRow[filedName+"_valid"] = correct;         
            setRowX(  JSON.parse(JSON.stringify(tmpRow)) );            
            //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );      
        }   
    

        const nGroupChange = (nName) =>{           
            
                console.log("Gr: " + nName);

                var tmpRow = row;
                tmpRow["nazwa_wlasna"] = nName + " - Dziennik";
                tmpRow["nazwa_wlasna_valid"] = true;         
                setRowX(  JSON.parse(JSON.stringify(tmpRow)) );  
           
        }

    
        const goNextNew = () => {
            console.log("goNext");
            //saveData();
        }


        const getTab = () => {
       
                
                    props.mainView.setProgress(-2);

                

                    fetch( Config.url + '/rest_v1_men,book_one', {
                        method: 'POST', 
                        body: JSON.stringify({id: props.id}), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                            '_p_dziecko_id_': props.userData.p_dziecko_id,
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                                props.mainView.setProgress(-1);        
                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                }else    
                                {
                                    setRowX(res.result);                      
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                props.mainView.setProgress(-1);
                    });
                            

                    return false;
}

        const onSelectTab = (e) => {
            setSelectedTab(e.currentTarget.getAttribute("atr-menu"));
            setSelectedTitle( " / " +  e.currentTarget.innerHTML);
        }


        const onSuccess = (e) => {
            props.onSuccess();
        }

        if(row == null)
        {
            setRowX([]);
            getTab();
            return <div>....</div>
        }

        if(row.id == null)
        {
              return <div>....</div>
        }


    var css_tematy = "";    
    var css_plan_dnia = "";    
    var css_plan_tygodnia = "";    
    var css_lista_dzieci = "";    
    var css_obecnosci = "";    
    var css_wydarzenia = "";    
    var css_zebrania = "";    
    var css_podstawa = "";    
    var css_ustawienia = "";    
    var css_pomoc_psychologa = "";    
    var css_kontrola = "";    
    var css_godziny = "";    

    if(selectedTab == "tematy") css_tematy = " tx_selected ";
    if(selectedTab == "plan_dnia") css_plan_dnia = " tx_selected ";
    if(selectedTab == "plan_tygodnia") css_plan_tygodnia = " tx_selected ";
    if(selectedTab == "lista_dzieci") css_lista_dzieci = " tx_selected ";
    if(selectedTab == "obecnosci") css_obecnosci = " tx_selected ";
    if(selectedTab == "wydarzenia") css_wydarzenia = " tx_selected ";
    if(selectedTab == "zebrania") css_zebrania = " tx_selected ";
    if(selectedTab == "podstawa") css_podstawa = " tx_selected ";
    if(selectedTab == "ustawienia") css_ustawienia = " tx_selected ";
    if(selectedTab == "pomoc_psychologa") css_pomoc_psychologa = " tx_selected ";
    if(selectedTab == "kontrola") css_kontrola = " tx_selected ";
    if(selectedTab == "godziny") css_godziny = " tx_selected ";


    var isSpecjalisty = (props.typ == "specjalisty" || row.typ == "specjalisty");

    var cssArchiwum = "";

    if(row.status == "nieaktywny")
    {
        cssArchiwum =  " calWrong ";
    }


    return    <div className="view_content">

                <br/>&nbsp; <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>

           
             
             <h3 className={"calColor " + cssArchiwum}>              
                 {row.nazwa_wlasna} / {row.rok_szkolny}      
             </h3>

              <ul className="block_menu">
                   {
                        !isSpecjalisty &&
                        <li className={"bm_item " + css_godziny} atr-menu="godziny" onClick={onSelectTab}>Godz. przyprow.</li>
                   }
                   <li className={"bm_item " + css_tematy} atr-menu="tematy" onClick={onSelectTab}>Zajęcia</li>
                   <li className={"bm_item " + css_plan_dnia}  atr-menu="plan_dnia" onClick={onSelectTab}>Plan ramowy</li>
                   <li className={"bm_item " + css_plan_tygodnia}  atr-menu="plan_tygodnia" onClick={onSelectTab}>Plan tygodniowy</li>
                   <li className={"bm_item " + css_lista_dzieci}  atr-menu="lista_dzieci" onClick={onSelectTab}>Dzieci</li>
                   {
                        !isSpecjalisty &&
                        <li className={"bm_item " + css_pomoc_psychologa}  atr-menu="pomoc_psychologa" onClick={onSelectTab}>Pomoc psycho./ped.</li>
                   }
                   <li className={"bm_item " + css_obecnosci}  atr-menu="obecnosci" onClick={onSelectTab}>Obecności</li>
                   {
                        !isSpecjalisty &&
                        <li className={"bm_item " + css_wydarzenia}  atr-menu="wydarzenia" onClick={onSelectTab}>Wycieczki</li>
                   }
                   <li className={"bm_item " + css_zebrania}  atr-menu="zebrania" onClick={onSelectTab}>Zebrania</li>
                   {
                        !isSpecjalisty &&
                        <li className={"bm_item " + css_podstawa}  atr-menu="podstawa" onClick={onSelectTab}>Podstawa prog.</li>
                   }
                   <li className={"bm_item " + css_kontrola}  atr-menu="kontrola" onClick={onSelectTab}>Kontrola dyr.</li>
                   <li className={"bm_item " + css_ustawienia}  atr-menu="ustawienia" onClick={onSelectTab}>Więcej</li>
                  
              </ul>      

    
             <div className="men_book_content">
                    {
                        selectedTab == "godziny" &&
                        <Hours  mainView={props.mainView} userData={props.userData} id={row.id}  status={row.status} title={row.nazwa_wlasna + " / " + row.rok_szkolny} />
                    }
                    {
                        selectedTab == "tematy" &&
                        <Lesson  mainView={props.mainView} userData={props.userData} id={row.id}  status={row.status} title={row.nazwa_wlasna + " / " + row.rok_szkolny} typ={isSpecjalisty ? "specjalisty" : row.typ} />
                    }
                    {
                        selectedTab == "plan_dnia" &&
                        <DayPlan  mainView={props.mainView} userData={props.userData} id={row.id} status={row.status}  title={row.nazwa_wlasna + " / " + row.rok_szkolny} />
                    }
                    {
                        selectedTab == "plan_tygodnia" &&
                        <WeekPlan  mainView={props.mainView} userData={props.userData} id={row.id} status={row.status}  title={row.nazwa_wlasna + " / " + row.rok_szkolny} />
                    }
                    {
                        selectedTab == "lista_dzieci" &&
                        <Kids  mainView={props.mainView} userData={props.userData} id={row.id} status={row.status}  title={row.nazwa_wlasna + " / " + row.rok_szkolny} />
                    }
                     {
                        selectedTab == "pomoc_psychologa" &&
                        <Psychologist  mainView={props.mainView} userData={props.userData} id={row.id} status={row.status}  title={row.nazwa_wlasna + " / " + row.rok_szkolny} />
                    }
                    {
                        selectedTab == "obecnosci" &&
                        <Free  mainView={props.mainView} userData={props.userData} id={row.id} status={row.status}  title={row.nazwa_wlasna + " / " + row.rok_szkolny} />
                    }
                    {
                        selectedTab == "wydarzenia" &&
                        <Trips  mainView={props.mainView} userData={props.userData} id={row.id} status={row.status}  title={row.nazwa_wlasna + " / " + row.rok_szkolny} />
                    }
                     {
                        selectedTab == "zebrania" &&
                        <Mets  mainView={props.mainView} userData={props.userData} id={row.id} status={row.status}  title={row.nazwa_wlasna + " / " + row.rok_szkolny} />
                    }
                     {
                        selectedTab == "podstawa" &&
                        <Dots  mainView={props.mainView} userData={props.userData} id={row.id} status={row.status}  title={row.nazwa_wlasna + " / " + row.rok_szkolny} />
                    }
                    {
                        selectedTab == "ustawienia" &&
                        <Settings  mainView={props.mainView} userData={props.userData} onBack={props.onBack} id={row.id} status={row.status}  title={row.nazwa_wlasna + " / " + row.rok_szkolny} row={row} onSuccess={onSuccess} typ={isSpecjalisty ? "specjalisty" : row.typ} />
                    }
                      {
                        selectedTab == "kontrola" &&
                        <Controls  mainView={props.mainView} userData={props.userData} id={row.id} status={row.status}  title={row.nazwa_wlasna + " / " + row.rok_szkolny} row={row} onSuccess={onSuccess} />
                    }
             </div>


    </div>
}


export default BooksEdit;